import { brandFieldErrorClass, brandFieldHelperClass, brandFieldLabelClass, brandFieldTitleClass } from "./fieldStyles";

export function FieldShell({ label, helper, error, className = "", showLabel = true, children }) {
  return (
    <label className={`${brandFieldLabelClass} ${className}`.trim()}>
      {showLabel && label ? <span className={brandFieldTitleClass}>{label}</span> : null}
      {children}
      {helper ? <span className={brandFieldHelperClass}>{helper}</span> : null}
      {error ? <span className={brandFieldErrorClass}>{error}</span> : null}
    </label>
  );
}
